<div class="min-h-screen bg-gray-50 flex flex-col font-prompt relative overflow-x-hidden pb-6">
    <!-- Decorative background elements -->
    <div
        class="absolute top-0 right-0 w-32 h-32 bg-(--background-color) rounded-full mix-blend-multiply filter blur-2xl opacity-20 -translate-y-1/2 translate-x-1/2 pointer-events-none">
    </div>
    <div
        class="absolute top-48 left-0 w-24 h-24 bg-orange-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 -translate-x-1/2 pointer-events-none">
    </div>

    <!------------------------------------------ Header Section ------------------------------------>
    <div class=" bg-(--background-color) rounded-b-[2rem] shadow-sm pb-8 pt-5 px-4 relative z-10">
        <!-- Back Button -->
        <div class="absolute left-4 top-5 w-[40px] h-[40px] bg-white rounded-full shadow-md flex justify-center items-center cursor-pointer active:scale-95 transition-transform z-20"
            (click)="goback()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor" class="w-5 h-5 text-gray-600">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
        </div>

        <!-- Header Titles -->
        <div class="text-center mt-1 px-10">
            <h1 class="text-lg font-bold text-(--main-text-color) tracking-wide">
                {{ currentLang === "TH" ? "เลือกผู้ให้บริการสถานที่จอดรถ" : "Select a service provider" }}
            </h1>
            <p class="text-xs text-(--sub-text-color) mt-1.5 leading-relaxed">
                {{ currentLang === "TH" ? "ค้นหาและเลือกสถานที่จอดรถเพื่อลงทะเบียนใช้งาน" : "Search and select a parking
                location to register" }}
            </p>
        </div>
    </div>

    <!------------------------------------------- Search Bar ------------------------------------->
    <div class="px-4 -mt-6 z-20 mb-4">
        <div
            class="bg-white rounded-2xl shadow-lg border border-slate-100/50 p-2 flex items-center gap-2 transition-all focus-within:ring-2 focus-within:ring-amber-300">
            <!-- Search Icon -->
            <div class="pl-2.5 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="searchParking" (input)="onSearchLocation()"
                placeholder="{{ currentLang === 'TH' ? 'ค้นหาสถานที่จอด...' : 'Search for a parking...' }}"
                class="w-full h-[40px] bg-transparent focus:outline-none text-gray-700 placeholder-gray-400 text-sm font-medium" />
            <!-- Clear Button -->
            <button *ngIf="searchParking"
                class="bg-gray-100 hover:bg-gray-200 p-2 rounded-xl active:scale-95 transition-all flex items-center justify-center"
                (click)="onClearSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-500" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    </div>

    <!------------------------------------------- Provider Cards / Scroll List --------------------------------------->
    <div class="flex-1 px-4 overflow-y-auto space-y-3 z-10 custom-scrollbar">

        <div *ngFor="let provider of (filteredProviders ? filteredProviders : ProvidersOptions)"
            (click)="openProvider(provider.id, provider.name)"
            class="w-full bg-white rounded-2xl border border-slate-100/60 shadow-sm hover:shadow-md active:scale-[0.99] transition-all duration-200 p-3 flex items-center gap-3 cursor-pointer relative overflow-hidden group">
            <!-- Highlight Accent Left Bar -->
            <div
                class="absolute left-0 top-0 bottom-0 w-1 bg-amber-400 scale-y-0 group-hover:scale-y-100 transition-transform duration-200 rounded-r">
            </div>

            <!-- Logo Container -->
            <div
                class="w-[72px] h-[72px] rounded-xl bg-slate-50 border border-slate-100/80 flex items-center justify-center p-1.5 flex-shrink-0 relative overflow-hidden shadow-inner">
                <img [src]="provider.logo_base64" alt="logo"
                    class="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105" />
            </div>

            <!-- Provider Details -->
            <div class="flex-1 min-w-0 flex flex-col pr-1">
                <h3
                    class="text-sm font-bold text-gray-800 tracking-wide line-clamp-1 group-hover:text-amber-600 transition-colors">
                    {{ provider.name }}
                </h3>
                <p class="text-xs text-gray-400 line-clamp-2 mt-1 leading-relaxed">
                    {{ provider.address || (currentLang === "TH" ? "ไม่มีข้อมูลที่อยู่" : "No address details
                    available") }}
                </p>
            </div>

            <!-- Action Button Indicator -->
            <div
                class="flex-shrink-0 w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center text-gray-400 group-hover:bg-amber-50 group-hover:text-amber-500 transition-all duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                    stroke="currentColor" class="w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </div>
        </div>

        <!------------------------------------------- Empty State --------------------------------------->
        <div *ngIf="(filteredProviders ? filteredProviders : ProvidersOptions).length === 0"
            class="flex flex-col items-center justify-center py-16 px-4 text-center">
            <div class="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-10 h-10 text-gray-400">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 13.5h3.86a2.25 2.25 0 012.008 1.24l.885 1.77a2.25 2.25 0 002.007 1.24h1.98a2.25 2.25 0 002.007-1.24l.885-1.77a2.25 2.25 0 012.007-1.24h3.86m-18 0h18a2.25 2.25 0 002.25-2.25V5.25A2.25 2.25 0 0017.25 3H6.75A2.25 2.25 0 004.5 5.25v6.75A2.25 2.25 0 002.25 13.5z" />
                </svg>
            </div>
            <p class="text-sm font-bold text-gray-600">
                {{ currentLang === 'TH' ? 'ไม่พบข้อมูลสถานที่จอด' : 'No Parking Locations Found' }}
            </p>
            <p class="text-xs text-gray-400 mt-1.5 max-w-[240px]">
                {{ currentLang === 'TH' ? 'ขออภัย ไม่พบผู้ให้บริการตรงกับคำค้นหาของคุณ' : 'Sorry, we couldn\'t find any
                service provider matching your search' }}
            </p>
        </div>
    </div>
</div>

<!-- CRITICAL: Place the app-pss-loading outside the outermost main div wrapper -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>